<template>
  <div class="list">
    <h3 class="title">我的上传</h3>
    <div class="item" v-for="item in list" :key="item.pid">
      <div class="item-name">
        <span style="background: red" v-if="item.stateText">{{
          item.stateText
        }}</span>
        {{ item.info.title }}
      </div>
    </div>
    <div class="none-text" v-if="!list.length">没有更多了</div>
  </div>
</template>

<script>
import COVER from "@/utils/COVER";
import COVERAPP from "@/utils/COVERAPP";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      list: [],
    };
  },
  computed: {
    ...mapState(["dialogData", "userinfo", "aid"]),
  },
  mounted() {
    document.title = "我的上传";
    this.getList();
  },
  methods: {
    getList() {
      COVER.$post("/apply/list", {
        aid: this.aid,
        userinfo: this.userinfo,
        page: 1,
        rows: 20,
      }).then((res) => {
        if (res.errno === 0) {
          this.list = res.data || [];
          return;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  padding: 5vw;
  box-sizing: border-box;
  font-size: 3.4vw;
  .title {
    text-align: center;
    font-size: 0.5rem;
    padding: 0.2rem 0.3rem;
    line-height: 1.5em;
    font-weight: normal;
  }
  .item {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    padding: 3vw 0;
    line-height: 1.4em;
    .item-name {
      width: 100%;
      height: 1.4em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      align-self: center;
      span {
        border-radius: 0.5vw;
        padding: 0 1vw;
        font-size: 2.8vw;
        color: white;
        background: #999;
        margin-right: 2vw;
      }
    }
    .item-link {
      flex-shrink: 0;
      margin-left: 3vw;
      text-decoration: none;
    }
  }
  .none-text {
    text-align: center;
    line-height: 2em;
  }
}
</style>